import React, { Component, Fragment } from "react";
import { googleAnalytics } from "../Services/googleAnalytics";
class OrderConfirmationGAContainer extends Component {
    constructor(props) {
      super(props);
      let cartdetails= JSON.parse(window.sessionStorage.getItem('cartdetails'));    
      let cartItem=  {
        event: 'purchase',
        ecommerce:{
          purchase:{
            actionField: {
              id: props.axNumber,                          
              revenue: Number(cartdetails.grandTotal).toFixed(2).toString(),                   
              shipping: Number(cartdetails.deliveryCost).toFixed(2).toString()                 
            },
            products:[]
          }
        }
      };
    if(cartdetails!=undefined)
    {
        cartdetails.orderRows.forEach((order, index) => {
          let price=order.axCustomerNetPrice/1000;
            let item={
                name: order.name,        
                id: order.axItemId,
                price: Number(price).toString(),
                category: order.breadcrumbs,   
                quantity: Number(order.weight*1000).toFixed(),
                unit:'grams',
                campaignProduct: order.isCampaignProduct
            };
            cartItem.ecommerce.purchase.products.push(item);
        });
    }
    googleAnalytics(cartItem);
    }
    render() {
        return (null);
      }
}

export default OrderConfirmationGAContainer;